import { render, staticRenderFns } from "./regis.vue?vue&type=template&id=df9a6d1e&"
import script from "./regis.vue?vue&type=script&lang=js&"
export * from "./regis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports